"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _simplebarReact = _interopRequireDefault(require("simplebar-react"));
require("simplebar-react/dist/simplebar.min.css");
var _jsxRuntime = require("react/jsx-runtime");
var Scrollbar = function Scrollbar(_ref) {
  var children = _ref.children,
    maxHeight = _ref.maxHeight;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_simplebarReact.default, {
    style: {
      maxHeight: maxHeight
    },
    children: children
  });
};
Scrollbar.defaultProps = {
  maxHeight: '300px'
};
var _default = exports.default = Scrollbar;